export default "__VITE_ASSET__CAvLNMm6__"